export default __webpack_public_path__ + "static/media/ICSE Computer Applications.8d631c0b.pdf";